import { Box, Button, Divider, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { makeStyles } from "@mui/styles";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      paddingRight: "40px",
    },
  },
}));

export default function ApproximateSubmission(props) {
  const classes = useStyles(props);
  const { reviewDate } = props;
  const dateFormat = moment(reviewDate?.submissionDate).format("MMMM Do YYYY")
  let weekDayName =  moment(reviewDate?.submissionDate).format('dddd');

  return (
    <div className={clsx(classes.root, 'my-24 pt-10')}>
      <Typography variant="subtitle1">
        Approximate Submission
      </Typography>
      <Divider sx={{ my: 2 }} />
      <ul className="flex">
        <li className="flex items-center">
          <FuseSvgIcon size={40}>heroicons-outline:calendar</FuseSvgIcon>
          <Box sx={{ ml: 2 }}>
            <Typography variant="body1">{weekDayName} | {dateFormat}</Typography>
            <Typography variant="caption" sx={{ opacity: 0.5}}>
              Check it on your google calendar
            </Typography>
          </Box>
        </li>
      </ul>
    </div>
  );
}
